// This function allow to reference async chunks
__webpack_require__.miniCssF = (chunkId) => {
	// return url for filenames based on template
	return "static/css/" + chunkId + "." + {"657":"950f15f2","658":"09f2eb4d"}[chunkId] + ".chunk.css";
};